import { useAuth } from '../contexts/AuthContext.jsx';

/**
 * Gates the entire router so nothing renders (and no API request fires)
 * until AuthProvider has finished its bootstrap pass — token validation,
 * silent refresh, and `/auth/me` fetch.
 *
 * Emits `data-testid="auth-ready"` with a `data-loading` attribute so
 * E2E tests can wait deterministically for auth bootstrap to finish:
 *
 *   await page.waitForSelector(
 *     '[data-testid="auth-ready"][data-loading="false"]'
 *   );
 */
export default function AuthGate({ children }) {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        data-testid="auth-ready"
        data-loading="true"
        className="centered-screen"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <div className="spinner" aria-label="Loading…" />
      </div>
    );
  }

  return (
    <div data-testid="auth-ready" data-loading="false" style={{ display: 'contents' }}>
      {children}
    </div>
  );
}
